/**
 * پرچم‌های محصول — کد بک‌اند/سرویس‌ها فعال می‌ماند؛ فقط نمایش UI کنترل می‌شود.
 * برای فعال‌سازی مجدد دستور جلسه: AGENDA_UI_ENABLED = true
 * برای فعال‌سازی مجدد تکرار جلسه در ویزارد: RECURRENCE_UI_ENABLED = true
 * برای فعال‌سازی مجدد فایل‌ها: FILES_UI_ENABLED = true
 * برای فعال‌سازی مجدد بایگانی مستقل: ARCHIVE_UI_ENABLED = true
 */
export const AGENDA_UI_ENABLED = false;

/** تکرار جلسه در ایجاد/ویرایش جلسه موقتاً از UI پنهان است. */
export const RECURRENCE_UI_ENABLED = false;

/** صفحه و مجوزهای فایل‌ها موقتاً از UI پنهان است. */
export const FILES_UI_ENABLED = false;

/** زیرگروه بایگانی (archive.*) موقتاً از UI پنهان است. */
export const ARCHIVE_UI_ENABLED = false;

/** قابلیت‌های AI که به دستور جلسه وابسته‌اند و با AGENDA_UI_ENABLED پنهان می‌شوند. */
export const AGENDA_RELATED_AI_CAPABILITIES = ['segmentation'];

/** پیشوند دسترسی‌هایی که از انتخابگر نقش پنهان‌اند ولی در API باقی می‌مانند. */
export const HIDDEN_PERMISSION_PREFIXES = [
  ...(AGENDA_UI_ENABLED ? [] : ['agenda']),
  ...(FILES_UI_ENABLED ? [] : ['files']),
  ...(ARCHIVE_UI_ENABLED ? [] : ['archive']),
];

function permissionPrefix(name) {
  if (!name || typeof name !== 'string') return '';
  const i = name.indexOf('.');
  return i === -1 ? name : name.slice(0, i);
}

/**
 * آیا این مجوز در UI انتخاب نقش/دسترسی نمایش داده شود؟
 * مجوزهای پنهان از کاتالوگ API حذف نمی‌شوند تا هنگام ویرایش نقش از بین نروند.
 */
export function isPermissionUiVisible(nameOrPerm) {
  const name = typeof nameOrPerm === 'string' ? nameOrPerm : nameOrPerm?.name;
  const subgroup =
    nameOrPerm && typeof nameOrPerm === 'object' && typeof nameOrPerm.subgroup === 'string'
      ? nameOrPerm.subgroup
      : '';
  const keys = [permissionPrefix(name), subgroup].filter(Boolean);
  if (!keys.length) return true;
  return keys.every((key) => !HIDDEN_PERMISSION_PREFIXES.includes(key));
}
